module.exports = __webpack_public_path__ + "static/img/IMG_20170304_114403-PANO.e443f498.jpg";